import { Pipe, PipeTransform } from '@angular/core';
import { getNamedEnum } from 'src/app/_helpers/enum-helper';

@Pipe({
  standalone: false, name: 'enumName' })
export class EnumNamePipe implements PipeTransform {
  transform(value: number | null | undefined, enumObj: Record<string, string | number>): string {
    return value == null ? '-' : (getNamedEnum(enumObj)[value] ?? '-');
  }
}
